import { render, staticRenderFns } from "./level-skill-subject.vue?vue&type=template&id=2f68c2e2&scoped=true&"
import script from "./level-skill-subject.vue?vue&type=script&lang=js&"
export * from "./level-skill-subject.vue?vue&type=script&lang=js&"
import style0 from "./level-skill-subject.vue?vue&type=style&index=0&id=2f68c2e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68c2e2",
  null
  
)

export default component.exports